import { render, staticRenderFns } from "./index.vue?vue&type=template&id=05b7e575&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b7e575",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05b7e575')) {
      api.createRecord('05b7e575', component.options)
    } else {
      api.reload('05b7e575', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=05b7e575&scoped=true", function () {
      api.rerender('05b7e575', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/integral/config/index.vue"
export default component.exports